import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifModalFooter,
  MotifButton,
  MotifInput,
  MotifFormField,
} from '@ey-xd/motif-react';
import * as formHelpers from '../../scripts/formHelpers';
import { Field, reduxForm } from 'redux-form';

const DeletePropertyMasterModal = ({
  show,
  onClose,
  initialValues,
  onConfirmDelete,
  errorMessage,
  handleDismissErrorMessage,
}) => {
  const [confirmText, setConfirmText] = useState('');
  const [confirmEnabled, setConfirmEnabled] = useState(false);

  const handleConfirmationInput = (e) => {
    setConfirmText(e.target.value);
    // Make the comparison case-insensitive
    if (e.target.value.toLowerCase() === 'delete') {
      setConfirmEnabled(true);
    } else {
      setConfirmEnabled(false);
    }
  };

  const handleClose = () => {
    setConfirmText('');
    onClose();
  };

  const submitForm = () => {
    onConfirmDelete(initialValues);
  };

  useEffect(() => {
    if (show) {
      setConfirmText('');
      setConfirmEnabled(false);
    }
  }, [show]);

  return (
    <MotifModal
      show={show}
      onClose={handleClose}
      variant="alt"
      size="md"
      aria-label="Delete Property Confirmation"
      data-testid="divDeleteNewPropertyModel"
    >
      <MotifModalHeader data-testid="mdHdrDeleteProperty">
        <span className="ml-2">Delete Property</span>
      </MotifModalHeader>
      <MotifModalBody>
        {formHelpers.showSubmissionError(
          errorMessage,
          handleDismissErrorMessage
        )}
        <MotifFormField>
          <div className="row">
            <div className="field col-md-12">
              <Field
                name="propertyName"
                component={formHelpers.renderField}
                type="text"
                label="Property Name"
                data-testid="txtPropertyName"
                className="w-100"
                disabled={true}
              />
            </div>
          </div>
        </MotifFormField>
        <span className="margin-bottom-1">
          Type &apos;Delete&apos; in the box below to confirm you want to make
          this change.
        </span>
        <div className="row">
          <div className="field col-md-12">
            <MotifInput
              type="text"
              onChange={handleConfirmationInput}
              value={confirmText}
              required={true}
              placeholder="Delete"
              data-testid="txtDelete"
            />
          </div>
        </div>
      </MotifModalBody>
      <MotifModalFooter>
        <MotifButton
          variant="secondary"
          onClick={handleClose}
          data-testid="btnCancel"
        >
          Cancel
        </MotifButton>
        <MotifButton
          variant="primary"
          disabled={!confirmEnabled}
          data-testid="btnConfirm"
          onClick={submitForm}
        >
          Confirm
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  );
};

DeletePropertyMasterModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirmDelete: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
  errorMessage: PropTypes.string,
  handleDismissErrorMessage: PropTypes.func,
};

export default reduxForm({
  form: 'deletePropertyMasterForm',
  enableReinitialize: true,
})(DeletePropertyMasterModal);
